<template>
  <section>
    <el-container>
      <el-header>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>充电监控</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <el-container class="container_box">
        <!-- 运营商充电桩数图 -->
        <el-aside
          class="tree-aside"
          style="max-width: 280px; min-width: 280px; width: auto"
        >
<!--          <el-input
            size="small"
            placeholder="请输入充电站关键字"
            v-model="stationNameIpt"
          >
          </el-input>-->
          <el-tree
            class="station-tree"
            :data="stationTree"
            :props="defaultProps"
            highlight-current
            :filter-node-method="filterNode"
            node-key="id"
            :default-expanded-keys="defaultShowNodes"
            @node-click="nodeClick"
            ref="tree"
          >
            <div
              :style="{
                color:
                  data.node.isCurrent && data.node.isLeaf
                    ? '#1cbbb4'
                    : '#333333',
              }"
              slot-scope="data"
            >
              <template v-if="data.node.level == 1">
                <el-image
                  src="static/image/province.png"
                  class="box-image"
                ></el-image>
              </template>
              <template v-if="data.node.level == 2">
                <el-image
                  src="static/image/city3.png"
                  class="box-image"
                ></el-image>
              </template>
              <template v-if="data.node.level == 3">
                <el-image
                  src="static/image/charge2.png"
                  class="box-image"
                ></el-image>
              </template>
              {{ ellipsis(data.data.label, 12) }}
            </div>
          </el-tree>
        </el-aside>
        <el-container>
          <el-main class="has-no-paddingtop page-component__scroll">
            <el-row :gutter="20">
              <el-col :span="16">
                <template>
                  <el-table
                    :data="tarGuns"
                    style="width: 100%"
                    border
                    height="272px"
                  >
                    <el-table-column type="index" width="50"> </el-table-column>
                    <el-table-column prop="pileCode" label="桩号" width="180">
                    </el-table-column>
                    <el-table-column prop="gunCode" label="枪号">
                    </el-table-column>
                    <el-table-column label="状态">
                      <template slot-scope="scope">
                        <el-tag
                          size="mini"
                          :color="items[scope.row.status.value].bgColor"
                          :style="`color:${
                            items[scope.row.status.value].color
                          };border-color:${
                            items[scope.row.status.value].bgColor
                          }`"
                          >{{ scope.row.status.message }}</el-tag
                        >
                      </template>
                    </el-table-column>
                    <el-table-column label="交直流">
                      <template slot-scope="scope">
                        <el-tag
                          size="mini"
                          :type="
                            scope.row.gunType == 'F'
                              ? 'success'
                              : scope.row.gunType == 'S'
                              ? 'warning'
                              : 'info'
                          "
                          >{{ gunType(scope.row.gunType) }}</el-tag
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-col>
              <el-col :span="8">
                <div class="chart" id="statusChart"></div>
              </el-col>
            </el-row>
            <!-- 顶部状态 -->
            <div class="all-port-div">
              <!-- 各个枪状态 -->
              <el-divider></el-divider>
              <template>
                <div v-if="activeName == 'list'">
                  <el-row :gutter="10">
                    <template v-for="(gun, index) in tarGuns">
                      <el-col
                        :xs="24"
                        :sm="24"
                        :md="12"
                        :lg="8"
                        :xl="6"
                        :key="index"
                        v-if="gun.status.value == 'charging'"
                      >
                        <div
                          class="port-div"
                          @click="switchClick('details', gun)"
                        >
                          <el-card class="box-card">
                            <el-tag
                              :style="{
                                color: items[gun.status.value].color,
                                backgroundColor:
                                  items[gun.status.value].bgColor,
                                borderColor: items[gun.status.value].bgColor,
                              }"
                            >
                              <template v-if="gun.gunCode">
                                {{ gun.gunCode }} /
                              </template>
                              <template v-if="gun.gunNumber">
                                {{ gun.gunNumber }}号 /
                              </template>
                              {{ gun.status.message }}
                            </el-tag>
                            <el-tooltip
                              class="item"
                              effect="dark"
                              content="点击查看详情"
                              placement="top-start"
                            >
                              <el-card class="box">
                                <el-row>
                                  <el-col :span="12">
                                    <el-image
                                      src="static/image/dianliang.png"
                                      class="box-image"
                                    >
                                    </el-image>
                                    <div class="box-div">
                                      {{ gun.totalPower }} kw·h
                                    </div>
                                  </el-col>
                                  <el-col :span="12">
                                    <el-image
                                      src="static/image/baifenbi.png"
                                      class="box-image"
                                    >
                                    </el-image>
                                    <div class="box-div">{{ gun.soc }} %</div>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col :span="12">
                                    <el-image
                                      src="static/image/dianya.png"
                                      class="box-image"
                                    >
                                    </el-image>
                                    <div class="box-div">
                                      {{ gun.voltage }} V
                                    </div>
                                  </el-col>
                                  <el-col :span="12">
                                    <el-image
                                      src="static/image/dianliu.png"
                                      class="box-image"
                                    >
                                    </el-image>
                                    <div class="box-div">
                                      {{ gun.current }} A
                                    </div>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col :span="12">
                                    <el-image
                                      src="static/image/gonglv.png"
                                      class="box-image"
                                    >
                                    </el-image>
                                    <div class="box-div">
                                      {{ gun.power }} kw
                                    </div>
                                  </el-col>

                                  <el-col :span="12">
                                    <el-image
                                      src="static/image/wendu.png"
                                      class="box-image"
                                    >
                                    </el-image>
                                    <div class="box-div">
                                      {{ gun.temperature }}℃
                                    </div>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col :span="12">
                                    <el-image
                                      src="static/image/ka.png"
                                      class="box-image"
                                    >
                                    </el-image>
                                    <div class="box-div">
                                      {{ source(gun.orderNo) }}
                                    </div>
                                  </el-col>
                                  <el-col :span="12">
                                    <el-image
                                      src="static/image/jiaozhiliu.png"
                                      class="box-image"
                                    >
                                    </el-image>
                                    <div class="box-div">
                                      {{ gunType(gun.gunType) }}
                                    </div>
                                  </el-col>
                                </el-row>
                              </el-card>
                            </el-tooltip>
                          </el-card>
                        </div>
                      </el-col>
                    </template>
                  </el-row>
                </div>
                <div v-if="activeName == 'details'" style="cursor: default">
                  <div class="title_box">
                    <div>
                      <h1 style="font-size: 18px">充电详情</h1>
                    </div>
                    <div>
                      <i
                        class="el-icon-close"
                        style="cursor: pointer; font-size: 20px"
                        @click="switchClick('list')"
                      ></i>
                    </div>
                  </div>
                  <Details
                    :detailsData="detailsData"
                    :lineChartLength="lineChartLength"
                  ></Details>
                </div>
              </template>
            </div>
            <template>
              <el-backtop target=".page-component__scroll" :bottom="100">
                <div
                  title="返回顶部"
                  style="
                     {
                      height: 100%;
                      width: 100%;
                      background-color: #f2f5f6;
                      box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
                      text-align: center;
                      line-height: 40px;
                      color: #1989fa;
                      border-radius: 50%;
                    }
                  "
                >
                  <i class="el-icon-caret-top"></i>
                </div>
              </el-backtop>
            </template>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </section>
</template>
<script>
import * as api from "../api/chargingMonitor";
import Chart from "echarts";
import Details from "@/module/operatingCenter/component/chargingMonitorDetails.vue";

export default {
  data() {
    return {
      tagSelecteds: [],
      timerTask: "",
      currentStationName: "",
      items: {
        all: {
          name: "all",
          color: "#1cbbb4",
          bgColor: "#d2f1f0",
          label: "全部:",
          value: 0,
        },
        charging: {
          name: "charging",
          color: "#0081ff",
          bgColor: "#cce6ff",
          label: "充电:",
          value: 0,
        },
        busy: {
          name: "busy",
          color: "#f37b1d",
          bgColor: "#fde6d2",
          label: "占用:",
          value: 0,
        },
        charge_appoint: {
          name: "charge_appoint",
          color: "#fbbd08",
          bgColor: "#fef2ced2",
          label: "预约:",
          value: 0,
        },
        free: {
          name: "free",
          color: "#39b54a",
          bgColor: "#d7f0db",
          label: "空闲:",
          value: 0,
        },
        charge_fault: {
          name: "charge_fault",
          color: "#e54d42",
          bgColor: "#fadbd9",
          label: "故障:",
          value: 0,
        },
        offline: {
          name: "offline",
          color: "#8799a3",
          bgColor: "#e7ebed",
          label: "故障:",
          label: "离线:",
          value: 0,
        },
        // { color: '字体颜色', bgColor: '背景颜色', label: '显示内容', value: 数量 },
      },
      visibleArrow: false,
      stationNameIpt: "",
      stationCode:"",
      operatorId:"",
      stations: [], // 原始数据
      guns: [],
      tarGuns: [],
      stationTree: [],
      defaultShowNodes: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      activeName: "list",
      detailsData: {}, //详情
      lineChartLength: 10, //数据长度显示最近几条数据
      // echarts
      statusChart: null, //状态
    };
  },
  components: {
    Details,
  },
  computed: {
    startType: function () {
      return function (startType) {
        if (startType === "0") {
          return "刷卡启动";
        } else if (startType === "1") {
          return "扫码启动";
        }else if(startType === 3){
          return "扫码启动";
        } else {
          return "未启动";
        }
      };
    },
    chargeTime: function () {
      return function (totalTime) {
        if (totalTime < 60) {
          return totalTime + "秒";
        }
        let chargeMin = Math.floor(totalTime / 60);
        let chargeSecond = totalTime % 60;
        if (chargeMin < 60) {
          return chargeMin + "分" + chargeSecond + "秒";
        } else {
          let chargeHour = Math.floor(chargeMin / 60);
          chargeMin = chargeMin % 60;
          return chargeHour + "时" + chargeMin + "分";
        }
      };
    },
    gunType: function () {
      return function (gunType) {
        if (gunType === "S") {
          return "交流";
        } else if (gunType === "F") {
          return "直流";
        } else {
          return "未知";
        }
      };
    },


    getStationCode(){
        this.stationCode= this.$store.state.stationCode
        return this.$store.state.stationCode
    },

    getOperatorId(){
      this.operatorId= this.$store.state.operatorId
      return this.$store.state.operatorId
    },
    source:function(e){
      return function(e){
       if(e){
        let source = e.substring(0,9)
        if(source == 'MA005DBW1'){
          return '快电'
        }else if(source == 'MA5FF58R7'){
          return '星络'
        }else if(source == 'MAC1F3P25'){
          return '加电'
        }else if(source == 'MA25CNM38'){
          return '新电途'
        }else{
          return '充小兽'
        }
       }else{
        return "互联互通"
       }
      }
    }

  },
  watch: {

    getStationCode(newValue,oldValue){
      if (newValue !== oldValue) {
        this.searchStationInfo(this.operatorId,this.stationCode);
      }
    },



    "$store.state.operatorId": {
      handler: function (newVal, oldVal) {
        let operatorIds = []
        operatorIds.push( sessionStorage.getItem('operatorId'));
        this.searchStationInfoByOperatorId(operatorIds);
      },
      deep: true,
    },

    // 根据名称筛选部门树
    stationNameIpt(val) {
      this.$refs.tree.filter(val);
    },
    stationTree: {
      handler(val) {
        // 我这里默认展开一级, 指定几级就往里遍历几层取到 id 就可以了
        if (val) {
          this.stationTree.forEach((item, index) => {
            if (index == 0) {
              this.defaultShowNodes.push(item.id);
              this.defaultShowNodes.push(item.children[0].id);
            }
          });
          // 默认展开第一个站点
          this.$nextTick(() => {
            let arr = document
              .querySelectorAll(".el-tree-node__content")[2]
              .click();
          });
        }
      },
      deep: true,
    },
  },
  created() {
    console.log("获取站点信息");
    //获取数据
    //let stationCode=sessionStorage.getItem('stationCode');
    let operatorIds = []
    operatorIds.push( sessionStorage.getItem('operatorId'));
    //this.searchStationInfo(operatorIds,stationCode);
    this.searchStationInfoByOperatorId(operatorIds);
  },
  beforeDestroy() {
    console.log("页面卸载");
    clearInterval(this.timerTask);
  },
  methods: {
    // 详情切换
    switchClick(tab, data) {
      this.activeName = tab;
      if (tab == "list") {
        this.detailsData = {};
      } else {
        this.detailsData = data;
        console.log(this.detailsData);
      }
    },
    // 定时请求
    inTimeDataTimerTask(stationId, stationName) {
      // 定时请求实时终端任务
      clearInterval(this.timerTask);
      this.currentStationName = stationName;
      this.getGunsInfo(stationId);
      var timerTask = setInterval(() => {
        this.getGunsInfo(stationId);
      }, 30000);
      this.timerTask = timerTask;
    },
    getGunsInfo(stationId) {
      let that = this;
      let params = stationId;
      api
        .getGunsInfo(params)
        .then((res) => {
          if (res.code === 0 && res.data) {
            let guns = [];
            for (let i in that.items) {
              that.items[i].value = 0;
            }
            for (let i = 0; i < res.data.length; i++) {

              let gun = {};
              let modules = [];
              let gunType = res.data[i].gun.fastOrSlowCode;
              let protocolCode=res.data[i].gun.protocol.code; //充电协议编码
              gun.protocol = res.data[i].gun.protocol.message; //充电协议
              gun.startTime = res.data[i].gun.startTime; //开始充电时间
              gun.gunType = gunType; //交流直流
              let voltage, current, chargePower;


              if(gunType === "F"){ //直流
                voltage =
                  Math.round(this.isNullReplace(res.data[i].cmd104.dcV, 0) * 10) /
                  100;
                current =
                  Math.round(this.isNullReplace(res.data[i].cmd104.dcI, 0) * 10) /
                  100;
              }else if(gunType === "S"){//交流
                voltage =
                  Math.round(this.isNullReplace(res.data[i].cmd104.acVA, 0) * 10) /
                  100;
                current =
                  Math.round(this.isNullReplace(res.data[i].cmd104.acIA, 0) * 10) /
                  100;
              }

              if (
                !res.data[i].cmd104.chargePower ||
                res.data[i].cmd104.chargePower === 0
              ) {
                chargePower = Math.round((voltage * current) / 10) / 100;
              } else {
                chargePower =
                  this.isNullReplace(res.data[i].cmd104.chargePower, 0) / 10;
              }
              gun.voltage = voltage; //电压
              gun.current = current; //电流
              gun.power = chargePower; //功率
              gun.totalPower =
                Math.round(
                  this.isNullReplace(res.data[i].cmd104.chargeQuantity)
                ) / 1000; // 充电量
              gun.fee =
                Math.round(this.isNullReplace(res.data[i].cmd104.fee, 0)) / 100; // 当前金额
              gun.soc = this.isNullReplace(res.data[i].cmd104.currentSOC, 0); // soc
              gun.gunNumber = res.data[i].gun.gunNum; // 几号枪
              gun.gunCode = res.data[i].gun.gunCode; // 枪编号
              gun.gunName = res.data[i].gun.gunName; // 枪名称
              gun.pileCode = res.data[i].gun.pileCode; //桩编号
              gun.orderNo = res.data[i].gun.orderNo; //订单编号
              gun.phone = this.isNullReplace(res.data[i].gun.phone, "无"); // 手机
              gun.cardNumber = this.isNullReplace(res.data[i].gun.cardNo, "无"); // 卡号
              gun.temperature = this.isNullReplace(
                res.data[i].cmd104.gunTemperature,
                "无"
              ); // 枪温度
              gun.totalTime = this.isNullReplace(
                res.data[i].cmd104.chargeTime,
                0
              ); // 充电时长
              gun.status = that.statusTranslate(res.data[i]); // 空闲状态等的类型

              gun.startWay = res.data[i].gun.startType; // 开启充电方式
              if(protocolCode==='cechlht'){//互联互通
                //启动方式
                gun.startWay=res.data[i].cmd104.chargeStartModel;
                //开启时间
                gun.startTime=res.data[i].cmd104.appointmentBegTime;
                //充电soc
                gun.soc = gun.soc==0? res.data[i].gun.soc: gun.soc;
              }

              gun.runtimeDay = "99"; //运行时间
              gun.modules = res.data[i].moduleInfo; //模块
              // 添加曲线数据
              if (!this.guns.length) {
                gun.voltageData = [voltage]; //电压data
                gun.currentData = [current]; //电流data
                gun.powerData = [chargePower]; //功率data
                gun.timeData = [this.chargeTime(gun.totalTime)];
              } else {
                // 筛选出时间相同的数据，因为它们是一样的
                if (
                  this.detailsData.timeData.slice(-1)[0] ==
                  this.chargeTime(gun.totalTime)
                ) {
                  return false;
                }

                if (this.guns[i].voltageData.length >= this.lineChartLength) {
                  this.guns[i].voltageData.shift();
                  this.guns[i].currentData.shift();
                  this.guns[i].powerData.shift();
                  this.guns[i].timeData.shift();
                }
                gun.voltageData = [...this.guns[i].voltageData, voltage]; //电压data
                gun.currentData = [...this.guns[i].currentData, current]; //电流data
                gun.powerData = [...this.guns[i].powerData, chargePower]; //功率data
                gun.timeData = [
                  ...this.guns[i].timeData,
                  this.chargeTime(gun.totalTime),
                ]; //功率data
              }

              guns = [...guns, gun];
            }
            this.guns = guns;
            if (this.detailsData.gunCode) {
              let obj = this.guns.filter((item) => {
                return this.detailsData.gunCode == item.gunCode;
              })[0];
              this.detailsData = obj;
            }

            that.sortGuns();
          }
        })
        .catch(() => {
          console.log("枪详情加载出错");
        });
    },
    sortGuns() {
      // 桶排序
      let guns = this.guns;
      let tags = Object.keys(this.items); // tags数组-按照这个顺序排序
      let tagGuns = [];
      for (let i = 0; i < tags.length; i++) {
        // 初始化桶
        tagGuns[tags[i]] = [];
      }
      for (let i = 0; i < guns.length; i++) {
        // 存入不同的桶中
        console.log(guns[i].status.value);
        tagGuns[guns[i].status.value].push(guns[i]);
      }
      // 将二维组合成一维，输出
      let tarGuns = [];
      for (let item in tagGuns) {
        tarGuns = [...tarGuns, ...tagGuns[item]];
      }
      this.tarGuns = tarGuns;
    },
    statusTranslate(data) {
      //console.log(data)
      this.items.all.value += 1; // 全部
      let value;
      let message;
      if (
        !data.gun.gunConnectionState ||
        data.gun.gunConnectionState.code == 0
      ) {
        this.items.offline.value += 1; // 离线
        return {
          code: "0",
          value: "offline",
          message: "离线",
        };
      }
      if (data.gun.state) {
        switch (data.gun.state.code) {
          case 0:
            this.items.free.value += 1; // 空闲
            value = "free";
            message = "空闲";
            break;
          case 2:
            this.items.charging.value += 1; // 正在充电中
            value = "charging";
            message = "正在充电";
            break;
          case 5:
            this.items.charge_appoint.value += 1; // 预约
            value = "charge_appoint";
            message = "预约";
            break;
          case 6:
            this.items.charge_fault.value += 1; // 故障
            value = "charge_fault";
            message = "故障";
            break;
          default:
            this.items.busy.value += 1; // 占用
            value = "busy";
            message = "占用";
        }
        return {
          code: data.gun.state.code,
          value: value,
          message: message,
        };
      } else {
        return {
          code: 0,
          value: "free",
          message: "空闲",
        };
      }
    },

    searchStationInfo(operatorIds,stationCode){
      let stations=[]
      if (operatorIds && operatorIds.length > 0) {
        // 普通有多个运营商的
        console.log(operatorIds);
        // 没有运营商的管理员？
      } else {
        operatorIds = [];
      }
      console.log("运营商编号：", operatorIds);
      // 获取地区接口
      api
        .getStations(operatorIds)
        .then((res) => {
          console.log(JSON.stringify(res.data));
          if (res.code === 0) {
            res.data.forEach(obj=>{
              if(obj.stationCode===stationCode){
                stations.push(obj)
                this.transformData(stations);
              }
            }) ;
          }
        })
        .catch(() => {});
    },


    searchStationInfoByOperatorId(operatorIds){
      let stations=[]
      if (operatorIds && operatorIds.length > 0) {
        // 普通有多个运营商的
        console.log(operatorIds);
        // 没有运营商的管理员？
      } else {
        operatorIds = [];
      }
      console.log("运营商编号：", operatorIds);
      // 获取地区接口
      api
        .getStations(operatorIds)
        .then((res) => {
          console.log(JSON.stringify(res.data));
          if (res.code === 0) {
            res.data.forEach(obj=>{
                stations.push(obj)
                this.transformData(stations);
            }) ;
          }
        })
        .catch(() => {});
    },


    transformData(stations) {
      if (!stations.length) {
        return;
      }
      // 转化原始数据
      let origins = stations;
      let targets = [];
      let provinceList = [];
      let cityLists = [];
      // let regionList = []
      let index, index2;
      for (let i = 0; i < origins.length; i++) {
        if (origins[i].province) {
          if ((index = provinceList.indexOf(origins[i].province)) !== -1) {
            // 判断省是否存在
            // 省存在
            // console.log("省存在")
            if (origins[i].city) {
              if ((index2 = cityLists[index].indexOf(origins[i].city)) !== -1) {
                // 判断市是否存在
                // 市存在
                // console.log("市存在")
                // console.log(origins[i].stationName)
                let target = {
                  id: origins[i].id,
                  label: origins[i].stationName,
                };
                targets[index].children[index2].children = [
                  ...targets[index].children[index2].children,
                  target,
                ];
              } else {
                //市不存在
                // console.log("市不存在")
                // console.log(origins[i].stationName)
                let target = {
                  id: origins[i].city,
                  label: origins[i].city,
                  children: [
                    {
                      id: origins[i].id,
                      label: origins[i].stationName,
                    },
                  ],
                };
                targets[index].children = [...targets[index].children, target];
                cityLists[index] = [...cityLists[index], origins[i].city];
              }
            }
          } else {
            // 省不存在，从省开始添加数据
            // console.log("省不存在, 从省开始添加数据")
            // console.log(origins[i].stationName)
            let target = {
              id: origins[i].province,
              label: origins[i].province,
              children: [
                {
                  id: origins[i].city,
                  label: origins[i].city,
                  children: [
                    {
                      id: origins[i].id,
                      label: origins[i].stationName,
                    },
                  ],
                },
              ],
            };
            provinceList = [...provinceList, origins[i].province]; // 添加省到省列表
            cityLists = [...cityLists, [origins[i].city]]; // 添加市到市列表
            targets = [...targets, target]; // 添加数据
          }
        }
      }
      console.log("转化后的树结构数据：", targets);
      // this.regionList = regionList
      this.stationTree = targets;
    },
    // 触发页面显示配置的筛选
    filterNode(value, data, node) {
      if (!value) {
        return true;
      }
      let level = node.level;
      let _array = []; //这里使用数组存储 只是为了存储值。
      this.getReturnNode(node, _array, value);
      let result = false;
      _array.forEach((item) => {
        result = result || item;
      });
      return result;
    },
    getReturnNode(node, _array, value) {
      let isPass =
        node.data && node.data.label && node.data.label.indexOf(value) !== -1;
      isPass ? _array.push(isPass) : "";
      this.index++;
      console.log(this.index);
      if (!isPass && node.level != 1 && node.parent) {
        this.getReturnNode(node.parent, _array, value);
      }
    },
    // 点击树形图
    nodeClick(data, node, cmp) {
      if (node.isLeaf && node.isCurrent) {
        this.activeName = "list";
        this.guns = [];
        this.detailsData = {};
        this.inTimeDataTimerTask(data.id, data.label);
        console.log("加载数据");
      }
    },
    ellipsis(value, length) {
      if (!value) return "";
      if (value.length > length) {
        return value.slice(0, length) + "...";
      }
      return value;
    },
    isNullReplace(data, rep) {
      if (data == null || data === "") {
        return rep;
      } else {
        return data;
      }
    },
    switchTag(tagName) {
      if (tagName !== "all") {
        let index = this.tagSelecteds.indexOf(tagName);
        if (index !== -1) {
          // 已选择
          this.tagSelecteds.splice(index, 1);
        } else {
          this.tagSelecteds.push(tagName);
        }
      }
    },
    initStatusChart() {
      this.statusChart = Chart.init(document.getElementById("statusChart"));
      let tarGuns = this.tarGuns;
      let items = this.items;
      let data = [];
      for (const key in items) {
        if (items.hasOwnProperty.call(items, key)) {
          const element = items[key];
          if (element.name !== "all" && element.value != 0) {
            data.push({
              value: element.value,
              name: element.label + element.value,
              itemStyle: { color: element.color },
            });
          }
        }
      }

      this.statusChart.setOption({
        title: {
          text: this.currentStationName + "枪口状态",
          left: "center",
          top: "10",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} <br/>占比:({d}%)",
        },
        legend: {
          orient: "vertical",
          right: "10",
          bottom: "10",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "50%",
            center: ["center", "55%"],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
  },
  beforeUpdate() {
    this.initStatusChart();
  },
};
</script>
<style scoped lang="less">
.container_box {
  // height: 800px;
  height: calc(100vh - 120px);
  padding: 10px !important;
  margin: 10px !important;
  background-color: #fff;
}

.station-tree {
  margin-top: 10px;
  font-size: 14px;

  .box-image {
    width: 18px;
    height: 18px;
  }
}

.el-tag + .el-tag {
  margin-left: 30px;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 0px;
  }
}

.has-no-paddingtop {
  padding-top: 0px;

  /deep/ .el-table {
    th,
    td {
      padding: 0 !important;
      height: 34px !important;
      line-height: 34px !important;
    }
  }

  .chart {
    width: 100%;
    height: 272px;
    border: 1px solid #ebeef5;
  }

  /deep/ .el-tabs__item {
    padding: 0;
    width: 0;
    height: 0;
  }
}

.title_box {
  display: flex;
  justify-content: space-between;
  padding: 0 20px 20px;
  box-sizing: border-box;

  h1 {
    padding: 0;
    margin: 0;
  }
}

.all-port-div {
  cursor: pointer;

  .port-div {
    font-size: 11px;
    text-align: center;
    width: 100%;
    min-width: 300px;
    // display: inline-block;
    margin: 5px 0;

    .box-card {
      /deep/ .el-card__body {
        padding: 10px;

        .box {
          text-align: left;
          margin-top: 10px;
          color: #8c939d;

          .box-image {
            vertical-align: middle;
            width: 20px;
            height: 20px;
          }

          .box-div {
            vertical-align: middle;
            display: inline-block;
          }
        }

        .el-tag {
          min-width: 80%;
        }
      }
    }
  }
}

.el-row {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/chargingMonitor.vue